@if (showTakeoverError()) {
    <div class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center">
        <ap-error [apError]="takeoverError()"></ap-error>
    </div>
}

@if (showConnectionError()) {
    <conversational-chat-connectionerror class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center">
    </conversational-chat-connectionerror>
}

@if (showRetryConnectionError()) {
    <conversational-chat-retryconnectionerror
        (refreshComponent)="refreshChatComponent()"
        class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center"
    >
    </conversational-chat-retryconnectionerror>
}

@if (showChat()) {
    <div class="ap-flex-fill chat-position-relative">
        @if (showLiveChatFaqPopUp()) {
            <conversational-chat-overlay-message (selectContinueConversation)="hideLiveChatFaqPopUp()" class="ap-width-100">
            </conversational-chat-overlay-message>
        }
        @if (idleTimerActive()) {
            <conversational-chat-inactivityprompt
                (promptSelectContinue)="promptContinueConversation()"
                (promptSelectEnd)="promptEndConversation()"
                class="ap-width-100"
            >
            </conversational-chat-inactivityprompt>
        }

        <div role="status" aria-live="polite" aria-atomic="true" class="ap-sr-only">
            {{ liveMessage1() }}
        </div>
        <div role="status" aria-live="polite" aria-atomic="true" class="ap-sr-only">
            {{ liveMessage2() }}
        </div>

        <klant-conversational
            class="ap-flex ap-flex-fill ap-flex-column"
            (sendAction)="onSendAction($event)"
            (sendMessage)="onSendMessage($event)"
        >
        </klant-conversational>
    </div>
}
@if (showSkeletonLoader()) {
    <conversational-chat-skeleton></conversational-chat-skeleton>
}
